import React from 'react';
import { ChevronsRightIcon, ChevronsLeftIcon, LayoutGridIcon, BoxIcon, SquareIcon, CircleIcon, CheckSquareIcon, SmartphoneIcon, ChevronDownIcon, ChevronRightIcon } from 'lucide-react';
interface SidebarSubcategoriesProps {
  activeCategory: string;
  activeSubcategory: string;
  subcategories: Record<string, any[]>;
  getCurrentCategoryName: () => string;
  handleSubcategorySelect: (subcategoryId: string) => void;
  toggleCategoriesCollapse: () => void;
  categoriesCollapsed: boolean;
  showCabinetMaterials: boolean;
  setCabinetMaterialSearch: (search: string) => void;
  setShowCabinetMaterials: (show: boolean) => void;
}
export function SidebarSubcategories({
  activeCategory,
  activeSubcategory,
  subcategories,
  getCurrentCategoryName,
  handleSubcategorySelect,
  toggleCategoriesCollapse,
  categoriesCollapsed,
  showCabinetMaterials,
  setCabinetMaterialSearch,
  setShowCabinetMaterials
}: SidebarSubcategoriesProps) {
  return <div className="w-40 border-r border-gray-200 dark:border-darkbg-border overflow-y-auto relative" data-id="element-974">
      {/* Collapse/Expand button - moved to subcategory column */}
      <div className="absolute left-0 top-2 z-10" data-id="element-975">
        <button onClick={toggleCategoriesCollapse} className="bg-white p-1.5 rounded-r-md border border-l-0 border-gray-200 shadow-sm text-gray-500 hover:text-gray-700 dark:bg-darkbg-secondary dark:border-darkbg-border dark:text-gray-400 dark:hover:text-gray-300" data-id="element-976">
          {categoriesCollapsed ? <ChevronsRightIcon className="h-4 w-4" data-id="element-977" /> : <ChevronsLeftIcon className="h-4 w-4" data-id="element-978" />}
        </button>
      </div>
      <div className="p-2" data-id="element-979">
        <h3 className="text-sm font-medium text-gray-700 dark:text-gray-300 mb-3 px-2" data-id="element-980">
          {getCurrentCategoryName()}
        </h3>
        {activeCategory === 'materials' ? <div className="mb-2" data-id="element-981">
            {/* Material category buttons with icons matching the image */}
            <button className={`w-full text-left px-4 py-2 text-sm flex items-center ${activeSubcategory === 'all' ? 'bg-gray-100 dark:bg-darkbg-primary' : 'hover:bg-gray-50 dark:hover:bg-darkbg-primary/50'}`} onClick={() => {
          handleSubcategorySelect('all');
          setShowCabinetMaterials(true);
          setCabinetMaterialSearch('');
        }} data-id="element-982">
              <LayoutGridIcon className="h-4 w-4 mr-2 text-gray-500 dark:text-gray-400" data-id="element-983" />
              <span className={`${activeSubcategory === 'all' ? 'text-blue-600 dark:text-accent-blue' : 'text-gray-600 dark:text-gray-400'}`} data-id="element-984">
                All
              </span>
            </button>
            <div data-id="element-985">
              <button className={`w-full text-left px-4 py-2 text-sm flex items-center justify-between ${activeSubcategory === 'cabinets' ? 'bg-gray-100 dark:bg-darkbg-primary' : 'hover:bg-gray-50 dark:hover:bg-darkbg-primary/50'}`} onClick={() => {
            handleSubcategorySelect('cabinets');
            setShowCabinetMaterials(true);
            setCabinetMaterialSearch('');
          }} data-id="element-986">
                <div className="flex items-center" data-id="element-987">
                  <BoxIcon className="h-4 w-4 mr-2 text-gray-500 dark:text-gray-400" data-id="element-988" />
                  <span className={`${activeSubcategory === 'cabinets' ? 'text-blue-600 dark:text-accent-blue' : 'text-gray-600 dark:text-gray-400'}`} data-id="element-989">
                    Cabinets
                  </span>
                </div>
                <ChevronDownIcon className="h-3 w-3 text-gray-500 dark:text-gray-400" data-id="element-990" />
              </button>
              {/* Cabinet Parts Dropdown - Always show when Cabinets is selected */}
              {activeSubcategory === 'cabinets' && <div className="ml-4" data-id="element-991">
                  <button className="w-full text-left px-4 py-2 text-sm hover:bg-gray-50 dark:hover:bg-darkbg-primary/50 flex items-center" onClick={() => {
              setShowCabinetMaterials(true);
              setCabinetMaterialSearch('');
            }} data-id="element-992">
                    <SquareIcon className="h-4 w-4 mr-2 text-gray-500 dark:text-gray-400" data-id="element-993" />
                    <span className="text-gray-600 dark:text-gray-400" data-id="element-994">
                      Front
                    </span>
                  </button>
                  <button className="w-full text-left px-4 py-2 text-sm hover:bg-gray-50 dark:hover:bg-darkbg-primary/50 flex items-center" onClick={() => {
              setShowCabinetMaterials(true);
              setCabinetMaterialSearch('');
            }} data-id="element-995">
                    <SquareIcon className="h-4 w-4 mr-2 text-gray-500 dark:text-gray-400" data-id="element-996" />
                    <span className="text-gray-600 dark:text-gray-400" data-id="element-997">
                      Body
                    </span>
                  </button>
                  <button className="w-full text-left px-4 py-2 text-sm hover:bg-gray-50 dark:hover:bg-darkbg-primary/50 flex items-center" onClick={() => {
              setShowCabinetMaterials(true);
              setCabinetMaterialSearch('');
            }} data-id="element-998">
                    <SquareIcon className="h-4 w-4 mr-2 text-gray-500 dark:text-gray-400" data-id="element-999" />
                    <span className="text-gray-600 dark:text-gray-400" data-id="element-1000">
                      Body interior
                    </span>
                  </button>
                  <button className="w-full text-left px-4 py-2 text-sm hover:bg-gray-50 dark:hover:bg-darkbg-primary/50 flex items-center justify-between" onClick={() => {
              setShowCabinetMaterials(true);
              setCabinetMaterialSearch('');
            }} data-id="element-1001">
                    <div className="flex items-center" data-id="element-1002">
                      <CircleIcon className="h-4 w-4 mr-2 text-gray-500 dark:text-gray-400" data-id="element-1003" />
                      <span className="text-gray-600 dark:text-gray-400" data-id="element-1004">
                        Counters
                      </span>
                    </div>
                    <ChevronRightIcon className="h-3 w-3 text-gray-500 dark:text-gray-400" data-id="element-1005" />
                  </button>
                  <button className="w-full text-left px-4 py-2 text-sm hover:bg-gray-50 dark:hover:bg-darkbg-primary/50 flex items-center" onClick={() => {
              setShowCabinetMaterials(true);
              setCabinetMaterialSearch('');
            }} data-id="element-1006">
                    <span className="w-4 h-4 mr-2 border-b-2 border-gray-500 dark:border-gray-400" data-id="element-1007"></span>
                    <span className="text-gray-600 dark:text-gray-400" data-id="element-1008">
                      Baseboard
                    </span>
                  </button>
                </div>}
            </div>
            <button className={`w-full text-left px-4 py-2 text-sm flex items-center ${activeSubcategory === 'floor' ? 'bg-gray-100 dark:bg-darkbg-primary' : 'hover:bg-gray-50 dark:hover:bg-darkbg-primary/50'}`} onClick={() => {
          handleSubcategorySelect('floor');
          setShowCabinetMaterials(true);
          setCabinetMaterialSearch('');
        }} data-id="element-1009">
              <CircleIcon className="h-4 w-4 mr-2 text-gray-500 dark:text-gray-400" data-id="element-1010" />
              <span className={`${activeSubcategory === 'floor' ? 'text-blue-600 dark:text-accent-blue' : 'text-gray-600 dark:text-gray-400'}`} data-id="element-1011">
                Floor
              </span>
            </button>
            <button className={`w-full text-left px-4 py-2 text-sm flex items-center ${activeSubcategory === 'walls' ? 'bg-gray-100 dark:bg-darkbg-primary' : 'hover:bg-gray-50 dark:hover:bg-darkbg-primary/50'}`} onClick={() => {
          handleSubcategorySelect('walls');
          setShowCabinetMaterials(true);
          setCabinetMaterialSearch('');
        }} data-id="element-1012">
              <CircleIcon className="h-4 w-4 mr-2 text-gray-500 dark:text-gray-400" data-id="element-1013" />
              <span className={`${activeSubcategory === 'walls' ? 'text-blue-600 dark:text-accent-blue' : 'text-gray-600 dark:text-gray-400'}`} data-id="element-1014">
                Walls
              </span>
            </button>
            <button className={`w-full text-left px-4 py-2 text-sm flex items-center ${activeSubcategory === 'windows' ? 'bg-gray-100 dark:bg-darkbg-primary' : 'hover:bg-gray-50 dark:hover:bg-darkbg-primary/50'}`} onClick={() => {
          handleSubcategorySelect('windows');
          setShowCabinetMaterials(true);
          setCabinetMaterialSearch('');
        }} data-id="element-1015">
              <CircleIcon className="h-4 w-4 mr-2 text-gray-500 dark:text-gray-400" data-id="element-1016" />
              <span className={`${activeSubcategory === 'windows' ? 'text-blue-600 dark:text-accent-blue' : 'text-gray-600 dark:text-gray-400'}`} data-id="element-1017">
                Windows
              </span>
            </button>
            <button className={`w-full text-left px-4 py-2 text-sm flex items-center justify-between ${activeSubcategory === 'doors' ? 'bg-gray-100 dark:bg-darkbg-primary' : 'hover:bg-gray-50 dark:hover:bg-darkbg-primary/50'}`} onClick={() => {
          handleSubcategorySelect('doors');
          setShowCabinetMaterials(true);
          setCabinetMaterialSearch('');
        }} data-id="element-1018">
              <div className="flex items-center" data-id="element-1019">
                <CheckSquareIcon className="h-4 w-4 mr-2 text-gray-500 dark:text-gray-400" data-id="element-1020" />
                <span className={`${activeSubcategory === 'doors' ? 'text-blue-600 dark:text-accent-blue' : 'text-gray-600 dark:text-gray-400'}`} data-id="element-1021">
                  Doors
                </span>
              </div>
              <ChevronRightIcon className="h-3 w-3 text-gray-500 dark:text-gray-400" data-id="element-1022" />
            </button>
            <button className={`w-full text-left px-4 py-2 text-sm flex items-center ${activeSubcategory === 'appliances' ? 'bg-gray-100 dark:bg-darkbg-primary' : 'hover:bg-gray-50 dark:hover:bg-darkbg-primary/50'}`} onClick={() => {
          handleSubcategorySelect('appliances');
          setShowCabinetMaterials(true);
          setCabinetMaterialSearch('');
        }} data-id="element-1023">
              <SmartphoneIcon className="h-4 w-4 mr-2 text-gray-500 dark:text-gray-400" data-id="element-1024" />
              <span className={`${activeSubcategory === 'appliances' ? 'text-blue-600 dark:text-accent-blue' : 'text-gray-600 dark:text-gray-400'}`} data-id="element-1025">
                appliances
              </span>
            </button>
          </div> : activeCategory === 'fronts' ? <div className="mb-2" data-id="element-1026">
            {/* Model category buttons with icons matching the image */}
            <button className={`w-full text-left px-4 py-2 text-sm flex items-center ${activeSubcategory === 'all' ? 'bg-gray-100 dark:bg-darkbg-primary' : 'hover:bg-gray-50 dark:hover:bg-darkbg-primary/50'}`} onClick={() => {
          handleSubcategorySelect('all');
        }} data-id="element-1027">
              <LayoutGridIcon className="h-4 w-4 mr-2 text-gray-500 dark:text-gray-400" data-id="element-1028" />
              <span className={`${activeSubcategory === 'all' ? 'text-blue-600 dark:text-accent-blue' : 'text-gray-600 dark:text-gray-400'}`} data-id="element-1029">
                All
              </span>
            </button>
            <button className={`w-full text-left px-4 py-2 text-sm flex items-center ${activeSubcategory === 'flat' ? 'bg-gray-100 dark:bg-darkbg-primary' : 'hover:bg-gray-50 dark:hover:bg-darkbg-primary/50'}`} onClick={() => {
          handleSubcategorySelect('flat');
        }} data-id="element-1030">
              <SquareIcon className="h-4 w-4 mr-2 text-gray-500 dark:text-gray-400" data-id="element-1031" />
              <span className={`${activeSubcategory === 'flat' ? 'text-blue-600 dark:text-accent-blue' : 'text-gray-600 dark:text-gray-400'}`} data-id="element-1032">
                Flat
              </span>
            </button>
            <button className={`w-full text-left px-4 py-2 text-sm flex items-center ${activeSubcategory === 'integrated-handle' ? 'bg-gray-100 dark:bg-darkbg-primary' : 'hover:bg-gray-50 dark:hover:bg-darkbg-primary/50'}`} onClick={() => {
          handleSubcategorySelect('integrated-handle');
        }} data-id="element-1033">
              <SquareIcon className="h-4 w-4 mr-2 text-gray-500 dark:text-gray-400" data-id="element-1034" />
              <span className={`${activeSubcategory === 'integrated-handle' ? 'text-blue-600 dark:text-accent-blue' : 'text-gray-600 dark:text-gray-400'}`} data-id="element-1035">
                Integrated Handle
              </span>
            </button>
            <button className={`w-full text-left px-4 py-2 text-sm flex items-center ${activeSubcategory === 'raised-panel' ? 'bg-gray-100 dark:bg-darkbg-primary' : 'hover:bg-gray-50 dark:hover:bg-darkbg-primary/50'}`} onClick={() => {
          handleSubcategorySelect('raised-panel');
        }} data-id="element-1036">
              <SquareIcon className="h-4 w-4 mr-2 text-gray-500 dark:text-gray-400" data-id="element-1037" />
              <span className={`${activeSubcategory === 'raised-panel' ? 'text-blue-600 dark:text-accent-blue' : 'text-gray-600 dark:text-gray-400'}`} data-id="element-1038">
                Raised Panel
              </span>
            </button>
            <button className={`w-full text-left px-4 py-2 text-sm flex items-center ${activeSubcategory === 'recessed-panel' ? 'bg-gray-100 dark:bg-darkbg-primary' : 'hover:bg-gray-50 dark:hover:bg-darkbg-primary/50'}`} onClick={() => {
          handleSubcategorySelect('recessed-panel');
        }} data-id="element-1039">
              <SquareIcon className="h-4 w-4 mr-2 text-gray-500 dark:text-gray-400" data-id="element-1040" />
              <span className={`${activeSubcategory === 'recessed-panel' ? 'text-blue-600 dark:text-accent-blue' : 'text-gray-600 dark:text-gray-400'}`} data-id="element-1041">
                Recessed Panel
              </span>
            </button>
            <button className={`w-full text-left px-4 py-2 text-sm flex items-center ${activeSubcategory === 'aluminum-frame' ? 'bg-gray-100 dark:bg-darkbg-primary' : 'hover:bg-gray-50 dark:hover:bg-darkbg-primary/50'}`} onClick={() => {
          handleSubcategorySelect('aluminum-frame');
        }} data-id="element-1042">
              <SquareIcon className="h-4 w-4 mr-2 text-gray-500 dark:text-gray-400" data-id="element-1043" />
              <span className={`${activeSubcategory === 'aluminum-frame' ? 'text-blue-600 dark:text-accent-blue' : 'text-gray-600 dark:text-gray-400'}`} data-id="element-1044">
                Aluminum Frame
              </span>
            </button>
          </div> : subcategories[activeCategory] && Array.isArray(subcategories[activeCategory]) && subcategories[activeCategory].length > 0 ? <div className="mb-2" data-id="element-1045">
            {subcategories[activeCategory].map(subcategory => <div key={subcategory.id} data-id="element-1046">
                <button onClick={() => handleSubcategorySelect(subcategory.id)} className={`w-full text-left px-4 py-2 text-sm ${activeSubcategory === subcategory.id ? 'bg-gray-100 dark:bg-darkbg-primary' : 'hover:bg-gray-50 dark:hover:bg-darkbg-primary/50'}`} data-id="element-1047">
                  <span className={`${activeSubcategory === subcategory.id ? 'text-blue-600 dark:text-accent-blue' : 'text-gray-600 dark:text-gray-400'}`} data-id="element-1048">
                    {subcategory.name}
                  </span>
                </button>
              </div>)}
          </div> : <div className="text-sm text-gray-500 dark:text-gray-400" data-id="element-1049">
            No subcategories
          </div>}
      </div>
    </div>;
}